module.exports = __webpack_public_path__ + "Roboto-Regular.woff?878ad7158f6fa9136d796d4bad613bc2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Regular/Roboto-Regular.woff?v=2.137
// module id = 196
// module chunks = 7